import { useSelector } from "react-redux"
import { overviewdataSelector } from "reducers/overview/overviewdata"
import OverviewHeader from "./OverviewHeader";
import classnames from "classnames";
import Button from "@mui/material/Button";
import { download } from "./OverviewController";
import {
    DataGrid,
    GridCheckIcon,
    GridCloseIcon
} from "@mui/x-data-grid";
import { useNavigate } from "react-router";
import { getUser } from "services/auth";

function Overview() {

    const overviewdata = useSelector(overviewdataSelector);
    const navigate = useNavigate();

    const requestTypes = {
        NV: "New Vendor",
        CV: "Change Vendor",
        EVT: "Extend Vendor Third Party",
        EVI: "Extend Vendor Intercompany",
        RV: "Reactivate Vendor"
    };

    const columns = [
        {
            field: "REQ_ID",
            headerName: "ID",
            width: 150
        },
        {
            field: "REQ_DATE",
            headerName: "DATE",
            width: 150
        },
        {
            field: "REQ_USR_NAME",
            headerName: "Created By",
            width: 200
        },
        {
            field: "REQ_TYP",
            headerName: "Request Type",
            width: 200,
            renderCell: (params) => {
                return requestTypes[params.value]
            }
        },
        {
            field: "LIFNR_NAME",
            headerName: "Vendor Name",
            width: 200
        },
        {
            field: "BUKRS",
            headerName: "Company Code",
            width: 150
        },
        {
            field: "STATUS",
            headerName: "Status",
            width: 200
        }

    ]

    const handleDownload = () => {
        console.log("handle download");
        download({ dataset: overviewdata.rawRequests }, getUser())
    }


    const handleRowClick = (event) => {
        console.log("handle row click", event.row.REQ_ID);
        navigate("/app/vendor/" + event.row.REQ_ID);
    }


    let rowData = overviewdata.requests
        ? overviewdata.requests
        : [];


    return (<article className="article">
        <div className="container-fluid no-breadcrumb chapter">
            <OverviewHeader></OverviewHeader>

            <div className="mt-4" style={{ height: "75vh", width: "100%" }}>
                <DataGrid
                    onRowClick={handleRowClick}
                    columns={columns}
                    rows={
                        // the menudata needs to be mapped, because it does not contain an ID by default (in the SAP data)
                        // that is why we map it, and add an id to every row.
                        // if not the DATAGRID will not work and throw an error
                        // alternatively adding an ID in the backend would have worked,
                        // but that will make the data dirty
                        rowData
                            ? rowData.map((item, index) => ({
                                id: index + 1,
                                ...item
                            }))
                            : []
                    }
                ></DataGrid>
            </div>
            <div className="downloadLink mt-4">
                <Button
                    color="info"
                    className={classnames("coolButton", "d-print-none")}
                    variant="contained"
                    onClick={() => {
                        handleDownload();
                    }}
                >
                    download
                </Button>
            </div>
        </div></article>)
}

export default Overview